import { AsyncDataState, IMPAction, IUserStore } from '../reduxTypes';

const DEFAULT_TEST_STORE: IUserStore = {
  memberCookieState: AsyncDataState.NotLoaded,
  siteHeaderMemberDataState: AsyncDataState.NotLoaded,
  tokenCookieState: AsyncDataState.NotLoaded,
  pageDataState: AsyncDataState.NotLoaded,
  privacyConsentStatus: {
    status: AsyncDataState.NotLoaded,
    state: {
      functional: false,
      targeting: false,
      performance: false,
      social: false
    }
  }
};

export enum UserStoreAction {
  SetTokenDataState,
  SetTokenData,
  SetMemberDataState,
  SetMemberData,
  SetSiteHeaderMemberDataState,
  SetSiteHeaderMemberData,
  SetPageDataState,
  SetPageData,
  PushUserError,
  SetPrivacyContestStatus
}

const userReducer = (
  state: IUserStore = DEFAULT_TEST_STORE,
  action: IMPAction<UserStoreAction>
): IUserStore => {
  switch (action.type) {
    case UserStoreAction.SetTokenDataState:
      return { ...state, tokenCookieState: action.payload };
    case UserStoreAction.SetTokenData:
      return { ...state, tokenCookie: action.payload };
    case UserStoreAction.SetMemberDataState:
      return { ...state, memberCookieState: action.payload };
    case UserStoreAction.SetMemberData:
      return { ...state, memberCookie: action.payload };
    case UserStoreAction.SetSiteHeaderMemberDataState:
      return { ...state, siteHeaderMemberDataState: action.payload };
    case UserStoreAction.SetSiteHeaderMemberData:
      return { ...state, siteHeaderMemberData: action.payload };
    case UserStoreAction.SetPageDataState:
      return { ...state, pageDataState: action.payload };
    case UserStoreAction.SetPageData:
      return { ...state, pageData: action.payload };
    case UserStoreAction.PushUserError:
      return { ...state, errors: [...(state?.errors ?? []), action.payload] };
    case UserStoreAction.SetPrivacyContestStatus:
      return { ...state, privacyConsentStatus: action.payload };
    default:
      return state;
  }
};

export default userReducer;
